import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { DashboardSidebar } from "@/components/DashboardSidebar";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { FlaskConical, ExternalLink, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

interface Projet { id: string; titre: string; resume: string; statut: string; lien?: string; interne?: string; image?: string }

// Les prochains projets de Grafton. Ajouter une entrée ici pour la voir apparaître dans l'onglet.
const PROJETS: Projet[] = [
  { id: "espace", titre: "L'espace physique Grafton IA", resume: "The AI Experience Store : une boutique immersive dédiée à l'IA, à l'entrepreneuriat et à l'exécution de projets. Six espaces, un parcours de la découverte à la réalisation.", statut: "Concept", interne: "/laboratoire/espace-physique", image: "/images/laboratoire/espace-facade.jpg" },
  { id: "robot", titre: "Grafton.Robot", resume: "Étude de quatre robots d'entreprise (Command, Sentinel, Nexus, Obelisk) capables de se connecter à vos systèmes et de piloter des agents IA. Les prix de l'étude vont de 45 000 € à 210 000 € : ce sont des estimations conceptuelles, pas des offres.", statut: "Étude conceptuelle", lien: "https://agent-rover-orchestrator.lovable.app/" },
  { id: "relay", titre: "Grafton sur WhatsApp", resume: "Un agent Grafton joignable par WhatsApp, pour les clients qui n'utilisent pas l'email. Le moteur existe en version d'essai.", statut: "En test" },
  { id: "climat", titre: "Le Grand Débat — Climat 2050", resume: "Un espace de débat citoyen animé par Grafton IA.", statut: "En préparation", lien: "http://demo.grafton-ia.com/climat/" },
  { id: "idees", titre: "La Bourse aux idées", resume: "Un lieu où les idées de projet sont déposées, discutées et mises en relation avec des porteurs.", statut: "En préparation", lien: "http://demo.grafton-ia.com/bourse-idees/" },
];

export default function Laboratoire() {
  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <DashboardSidebar />
        <main className="flex-1 min-w-0">
          <header className="h-14 flex items-center gap-3 border-b border-border/50 px-4">
            <SidebarTrigger />
            <FlaskConical className="h-5 w-5 text-primary" />
            <h1 className="text-lg font-semibold">Le laboratoire</h1>
          </header>
          <div className="max-w-4xl mx-auto px-4 md:px-6 py-6 space-y-5" data-testid="laboratoire">
            <p className="text-sm text-muted-foreground">Ce que Grafton IA prépare. Ces projets ne sont pas encore des offres : ils montrent la direction que nous prenons.</p>
            <div className="grid gap-4 sm:grid-cols-2">
              {PROJETS.map((p) => (
                <Card key={p.id} className="flex flex-col overflow-hidden">
                  {p.image && <img src={p.image} alt={p.titre} loading="lazy" className="w-full object-cover" style={{ aspectRatio: "16 / 9" }} />}
                  <CardHeader>
                    <div className="mb-1"><Badge variant="outline" className="text-[10px]">{p.statut}</Badge></div>
                    <CardTitle className="text-lg">{p.titre}</CardTitle>
                    <CardDescription>{p.resume}</CardDescription>
                  </CardHeader>
                  {p.interne && (
                    <CardContent className="mt-auto">
                      <Link to={p.interne} className="text-xs text-primary inline-flex items-center gap-1 hover:underline">Découvrir le projet <ArrowRight className="h-3 w-3" /></Link>
                    </CardContent>
                  )}
                  {p.lien && (
                    <CardContent className="mt-auto">
                      <a href={p.lien} target="_blank" rel="noreferrer" className="text-xs text-primary inline-flex items-center gap-1 hover:underline">Voir l'aperçu <ExternalLink className="h-3 w-3" /></a>
                    </CardContent>
                  )}
                </Card>
              ))}
            </div>
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
}
